<template>
	<v-container id="customers-page-overview">
		<v-row>
			<v-col cols="12" class="text size-large weight-bold font-alt">
				Tableau de bord
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<div class="ctn__card-items-count">
					<CardItemCount
						:label="'Sms restants'"
						:hint="'sms'"
						:value="manager.sms_amount"
					></CardItemCount>

					<CardItemCount
						:label="'Emails restants'"
						:value="manager.email_amount"
						:hint="'email'"
					></CardItemCount>
				</div>
			</v-col>
		</v-row>
		<v-row class="px-3 mt-8">
			<v-col cols="12" class="colored-bg">
				<v-row class="pa-3">
					<v-col cols="12">
						<div class="text size-medium color-black-base">Évolution des inscrits opt-in de la base</div>
					</v-col>
					<v-col cols="12">
						<v-row >
							<v-col 
								lg="9"
								sm="12"
								md="12"
							>
								<v-card class="theme-card pt-11 pb-7 px-10">
									<chart-line :collection="optInHistory" collection-label="label" collection-value="value" color="purple"/>
								</v-card>
							</v-col>
							<v-col 
								lg="3"
								md="12"
								:class="{
									'd-flex justify-space-between': $vuetify.breakpoint.md 
								}" 
							>
								<kpi-trend  v-for="(card, index) in kpiTrends" :key="index"
									:class="{
										'mt-1 mb-8' : $vuetify.breakpoint.md, 
										'mt-8' : index > 0 && !$vuetify.breakpoint.md,
										'mr-3' : index < 2 && $vuetify.breakpoint.md
									}"
									:label="card.label"
									:color="card.color"
									:trend="card.trend"
									:icon="card.icon"
									:value="card.value"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12">
						<div class="text size-medium color-black-base">Segments de base</div>
					</v-col>
					<v-col cols="12">
						<v-row class="px-2">
							<v-col class="px-1" sm="4" md="2" v-for="(category, index) in categories" :key="index">
								<category-details
									:color="category.color"
									:label="category.label"
									:description="category.description"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12">
						<div class="text size-medium color-black-base">Derniers utilisateurs acquis</div>
					</v-col>
					<v-col cols="12">
						<div v-if="!dataLoaded">
							Loading ...
						</div>
						<table-users v-else />
					</v-col>
					<v-col cols="12" class="text-center">
						<v-btn class="theme-btn shape-rounded filled-purple glow drawer-button">En savoir plus</v-btn>
					</v-col>
				</v-row>
				<v-row>
					
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script type="text/javascript">

	import chartLine from '@/components/charts/chart-line'
	import kpiTrend from '@/components/cards/kpi-trend'
	import categoryDetails from '@/components/cards/category-details'
	import tableUsers from './table-users'
	import CardItemCount from '@/components/cards/dashboard/card-item-count.vue';

    export default {
        components: {
        	chartLine,
        	kpiTrend,
        	categoryDetails,
        	tableUsers,
			CardItemCount
        },
        props : {
            
        },
        data () {
            return {
            }
        },
        computed : {
            kpiTrends () {
            	return this.$store.state.userOverview.kpiTrends;
            },
            optInHistory () {
            	return this.$store.state.userOverview.optInHistory;
            },
            categories () {
            	return this.$store.state.segments.list;
            },
			dataLoaded () {
				return this.$store.state.customer.dataLoaded;
			},
			manager() {
				return this.$store.state.auth.users.data;
			},
        },
        created () {
			this.$store.dispatch('dashboardV2/loadAnalytics', {
				success : () => {
					this.$store.commit('userOverview/setKpiTrends', {
						index : 0,
						value : this.$store.state.dashboardV2.analytics.data.kpi.nb_registration
					});
					this.$store.commit('userOverview/setKpiTrends', {
						index : 2,
						value : this.$store.state.dashboardV2.analytics.data.kpi.nb_registration
					});
				}
			});
			this.$store.dispatch('customer/loadCustomerData');
			this.$store.dispatch('segments/getSegments');
        },
        methods : {
            
        }
    }

</script>

<style lang="scss">
	.ctn__card-items-count {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 5rem;
	}
</style>